module.exports = __webpack_public_path__ + "img/Risk_Rate_v3_24.edf7a64d.png";